import styled from 'styled-components';
import { ColumnDiv } from 'styles/elements/div';
import { PrimaryButton } from 'styles/elements/buttons/primaryCare';
import { SecondaryButton } from 'styles/elements/buttons';
import { Spinner, BubblePulseLoader } from 'styles/blocks/spinner/eTriageSpinner';

const Modal = styled(ColumnDiv)`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;

const Overlay = styled(ColumnDiv)`
  flex: 1;
  background-color: ${props => `${props.theme.backgroundColorPrimary}88`};
`;

const ModalContent = styled(ColumnDiv)`
  background-color: #004f73;
  border: 1px solid white;
  padding: 80px;
  border-radius: 30px;
  width: 50%;
  margin: 180px auto;
  text-align: center;
`;

const Text = styled.p`
  font-size: 40px;
  margin: 0;
  color: white;
  font-family: ${props => props.theme.fontFamilyLight};
`;

const HeaderText = styled(Text)`
  margin-bottom: 50px;
`;

const HeaderImage = styled(Text)`
  margin-bottom: 26px;
  font-size: 60px;
`;

const Header = styled(Text)`
  font-size: 50px;
  margin-bottom: 50px;
`;

const SmallText = styled(Text)`
  font-size: 35px;
`;

const ConfirmButton = styled(PrimaryButton)`
  border-radius: 50px;
  height: 100px;
  padding: 0 40px;
  margin: 20px 0;
  margin-bottom: 30px;
  font-size: 40px;
  justify-content: center;
  align-items: center;
  display: flex;
`;

const CancelButton = styled(SecondaryButton)`
  border-radius: 50px;
  height: 100px;
  padding: 0 0px;
  margin: 0px 0;
  justify-content: center;
  align-items: center;
  display: flex;
  font-size: 40px;
  background-color: transparent;
  text-decoration: none;
`;

Modal.Overlay = Overlay;
Modal.ConfirmButton = ConfirmButton;
Modal.CancelButton = CancelButton;
Modal.Header = Header;
Modal.HeaderImage = HeaderImage;
Modal.HeaderText = HeaderText;
Modal.Text = Text;
Modal.SmallText = SmallText;
Modal.ModalContent = ModalContent;
Modal.Spinner = Spinner;
Modal.BubblePulseLoader = BubblePulseLoader;

export default Modal;
